module.exports = __webpack_public_path__ + "static/media/arrow-up.a0a8df4c.svg";